import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { formatIncomeAnswer, resolveHonorificKey, formatDepartment } from "../../utils/str"
import { HONORIFICS } from "../../constants/constants"
import Loader from "./loader"

const styles = theme => ({
  root: {
    padding: "45px 30px",
    boxSizing: "border-box",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "45px 20px",
    },
  },

  title: {
    marginTop: "16px",
    textAlign: "center",
    lineHeight: "28px",
    fontSize: "28px",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "23px",
    },
  },

  blockTitle: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "30px",
    borderBottom: "1px solid #D8DBDF"
  },

  relevantTitle: {
    paddingBottom: "10px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
    },
  },

  blockContainer: {
    position: "relative",
    minHeight: "unset",
    boxSizing: "border-box",

    [theme.breakpoints.down("xs")]: {
      minHeight: "unset",
    },
  },

  listContainer: {
    margin: "0",
    paddingLeft: "15px",
  },

  link: {
    color: "#1866FF",
    textDecoration: "underline",
    "&:visited": {
      color: " #13367B",
      textDecoration: "underline",
    }
  },

  emptyContainer: {
    height: '300px',
  },
})

class FaqProfile extends React.Component {
  relevantRender () {
    const { classes, item, relevantKeymans, departmentRelevantKeyman, honorificRelevantKeyman } = this.props
    const honorificKey = resolveHonorificKey(item.honorific)
    const honorific = HONORIFICS.find(item => item.value === honorificKey)

    if (!departmentRelevantKeyman && !honorificRelevantKeyman && Object.keys(relevantKeymans).length === 0) {
      return null
    } else {
      return (
        <div>
          <div className={classes.blockTitle}>
            <div className={classes.relevantTitle}>
              {item.name}さんの勤める{item.company_name}の近しい決裁者は？
            </div>
          </div>
          {(!!departmentRelevantKeyman || !!honorificRelevantKeyman) && (
            <div className={classes.blockContainer}>
              <div>
                <p style={{ color: "inherit", marginTop: "10px" }}>
                  {!!departmentRelevantKeyman && (
                    <span>{formatDepartment(item.honorific)}部門の
                      <a
                        className={classes.link}
                        href={`/keymans/${departmentRelevantKeyman.id}`}
                      >
                        {departmentRelevantKeyman.name}
                      </a>
                      さん
                    </span>
                  )}
                  {(!!departmentRelevantKeyman && !!honorificRelevantKeyman) && (
                    <span>、</span>
                  )}
                  {!!honorificRelevantKeyman && (
                    <span>{honorific.name}の
                      <a
                      className={classes.link}
                      href={`/keymans/${honorificRelevantKeyman.id}`}
                      >
                      {honorificRelevantKeyman.name}
                      </a>
                      さん
                    </span>
                  )}
                  <span>などが部門や役職が近しい決裁者です。</span>
                </p>
              </div>
            </div>
          )}
          {Object.keys(relevantKeymans).length !== 0 && (
            <div className={classes.blockContainer}>
              <div>
                <p style={{ color: "inherit", marginTop: "10px" }}>
                  <ul className={classes.listContainer}>
                    {relevantKeymans.map((item, i) => (
                      <li key={i}>
                        <a
                          className={classes.link}
                          href={`/keymans/${item.id}`}
                        >
                          {item.name}　{item.honorific}
                        </a>
                      </li>
                    ))}
                  </ul>
                </p>
              </div>
            </div>
          )}
        </div>
      )
    }
  }

  render() {
    const { classes, item, isLoadingRelevantKeymans } = this.props
    let incomeAnswer = ''
    if (item && item.annual_income) {
      incomeAnswer = formatIncomeAnswer(item)
    }

    return (
      <div className={classes.root}>
        <div>
          <div className={classes.title}>よくあるご質問</div>
        </div>
        {item && item.annual_income && (
          <div>
            <div className={classes.blockTitle}>
              <div style={{ paddingBottom: "10px" }}>
                {item.name}さんの勤める{item.company_name}の平均年収は？
              </div>
            </div>
            <div className={classes.blockContainer}>
              <div>
                <p style={{ color: "inherit", marginTop: "10px" }}>
                  {incomeAnswer}
                </p>
              </div>
            </div>
          </div>
        )}
        {!!isLoadingRelevantKeymans && (
          <div className={classes.emptyContainer}>
            <Loader></Loader>
          </div>
        )}
        {this.relevantRender()}
      </div>
    )
  }
}

FaqProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

export default withStyles(styles)(FaqProfile)
